import { Component, OnInit } from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import {DataManagementService} from '../../services/data-management.service';

@Component({
  selector: 'app-manual-allotments',
  templateUrl: './manual-allotments.component.html',
  styleUrls: ['./manual-allotments.component.css']
})
export class ManualAllotmentsComponent implements OnInit {
  public modalReference: NgbModalRef;
  students = [];
  errorMessage: string = undefined;
  allotmentFlag;

  constructor(private modal: NgbModal,
              private dmService: DataManagementService) { }

  getGeneratedAllotments() {
    this.students = [];
    if (this.allotmentFlag === false) {
      this.errorMessage = 'There is no data available for Student Allotment Details.';
    } else {
      this.dmService.getStudents().subscribe(students => {
        for (let i = 0; i < students.data.length; i++) {
          if (students.data[i].allotment === true) {
            this.students.push(students.data[i]);
          }
        }
      });
    }
  }

  generateAllotments(): void {
    const that = this;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to generate Allotments?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          localStorage.setItem('allotmentFlag', 'true');
          that.allotmentFlag = JSON.parse(localStorage.getItem('allotmentFlag'));
          resolve(true);
        });
      },
      allowOutsideClick: false,
    }).then(function (result) {
      if (result.value === true) {
        that.getGeneratedAllotments();
        Swal({
          title: 'Success',
          type: 'success',
          html: '<p>Allotments generated successfully.</p>',
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
    });
  }

  clearAllotments(): void {
    const that = this;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to Clear Allotments?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          localStorage.setItem('allotmentFlag', 'false');
          that.allotmentFlag = JSON.parse(localStorage.getItem('allotmentFlag'));
          that.students = [];
          resolve(true);
        });
      },
      showLoaderOnConfirm: true,
    }).then(function (result) {
      if (result.value === true) {
        that.getGeneratedAllotments();
        Swal({
          title: 'Success',
          type: 'success',
          width: 600,
          padding: 80,
          showCancelButton: false,
          showConfirmButton: true,
          html: '<p>Allotments cleared successfully.</p>',
        });
      }
    }, function (cancel) {
      console.log(cancel);
    }).catch(function (error) {
    });
  }

  closeModal(): void {
    this.modalReference.close();
  }

  ngOnInit() {
    if (!localStorage.hasOwnProperty('allotmentFlag')) {
      localStorage.setItem('allotmentFlag', 'false');
    }
    if (localStorage.hasOwnProperty('allotmentFlag')) {
      this.allotmentFlag = JSON.parse(localStorage.getItem('allotmentFlag'));
    }
    this.getGeneratedAllotments();
  }
}
